<template>
  <div class="h-100">
    <v-chart ref="chart" :options="options" :init="init" />
  </div>
</template>

<script>
import liquidChartable from '../../../components/liquidChartable';

export default {
  mixins: [liquidChartable],
  props: {
    // BEGIN::Removed.by.KWShin.2025.11.29.
    // title: String,
    // storeName: {
    //   type: String,
    //   required: true,
    // },
    // FINISH::Removed.by.KWShin.2025.11.29.
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      data: {
        value: '',
        type: 'percent',
      },
    };
  },
  computed: {
    // BEGIN::Added.by.KWShin.2025.11.29.
    title() {
      return this.$t('dv.title.os.mem');
    },
    isWs() {
      return this.descendants.find(d => d.active).supportWebService;
    },
    // FINISH::Added.by.KWShin.2025.11.29.
    // BEGIN::Removed.by.KWShin.2025.11.29.
    // descendants() {
    //   return this.$store.getters[`${this.storeName}/get`];
    // },
    // descendant() {
    //   return (this.descendants || []).find(d => d.active);
    // },
    // FINISH::Removed.by.KWShin.2025.11.29.
  },
  watch: {
    value(data) {
      this.setData(data);
    },
  },
  methods: {
    setData(data) {
      // BEGIN:Modified.by.KWShin.2025.11.29.
      // const [result] = data;
      // if (this.descendant.supportWebService) this.data.value = parseInt(result?.memUsedRate || 0);
      // else this.data.value = parseInt(result?.memUtil || 0);
      if (data.length > 0) {
        let sum = 0;
        data.forEach(datum => {
          if (this.isWs) {
            sum += parseInt(datum.memUsedRate || 0);
          } else {
            sum += parseInt(datum.memUtil || 0);
          }
        });
        this.data.value = Math.ceil(sum / data.length);
      } else {
        this.data.value = '0';
      }
      // FINISH:Modified.by.KWShin.2025.11.29.
    },
  },
};
</script>
